import autoSizeFromParentBoundsFactory from './auto-size-from-parent-bounds';

export default autoSizeFromParentBoundsFactory;
export { autoSizeFromParentBoundsFactory };
